module.exports = {
  DOMAIN_URL: process.env.VUE_APP_DOMAIN_URL,
  API_URL: process.env.VUE_APP_API_URL
};
